import { render, staticRenderFns } from "./LeaderForm.vue?vue&type=template&id=2e47f90e&scoped=true"
import script from "./LeaderForm.vue?vue&type=script&lang=js"
export * from "./LeaderForm.vue?vue&type=script&lang=js"
import style0 from "./LeaderForm.vue?vue&type=style&index=0&id=2e47f90e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e47f90e",
  null
  
)

export default component.exports